var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "#FFF6F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1073_55677)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8687 82.5C66.1182 71.0987 56.6327 62.0834 45.0415 62.0834C43.5432 62.0834 42.0801 62.234 40.6665 62.521V50.4167C40.6665 47.195 43.2782 44.5834 46.4998 44.5834H87.3332C90.5548 44.5834 93.1665 47.195 93.1665 50.4167V76.6667C93.1665 79.8884 90.5548 82.5 87.3332 82.5H66.8687ZM84.8377 49.949L66.9165 59.5989L48.9953 49.949C47.9315 49.3762 46.6049 49.7742 46.0321 50.8379C45.4594 51.9017 45.8574 53.2283 46.9211 53.8011L65.8794 64.0094C66.5269 64.358 67.3062 64.358 67.9536 64.0094L86.9119 53.8011C87.9757 53.2283 88.3736 51.9017 87.8009 50.8379C87.2281 49.7742 85.9015 49.3762 84.8377 49.949Z",
    fill: "#FF641B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3335 79.5834C53.9443 79.5834 55.2502 80.8892 55.2502 82.5V91.25C55.2502 92.8609 53.9443 94.1667 52.3335 94.1667H37.7502C36.1393 94.1667 34.8335 92.8609 34.8335 91.25V82.5C34.8335 80.8892 36.1393 79.5834 37.7502 79.5834V78.125C37.7502 74.098 41.0148 70.8334 45.0418 70.8334C49.0689 70.8334 52.3335 74.098 52.3335 78.125V79.5834ZM45.0418 73.75C42.6256 73.75 40.6668 75.7088 40.6668 78.125V79.5834H49.4168V78.125C49.4168 75.7088 47.4581 73.75 45.0418 73.75Z",
    fill: "#FF641B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1073_55677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(29 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finishIcon.83a3dc90b494ed26f55afafd1096fc56.svg";
export { ForwardRef as ReactComponent };